export namespace ServiceLevelConstants {
  export const AMBULATORY_DOOR_TO_DOOR_CODE = 'AD2D';
  export const NON_AMBULATORY_CURB_TO_CURB_CODE = 'NAC2C';
  export const AMBULATORY_CURB_TO_CURB_CODE = 'AC2C';
  export const NON_AMBULATORY_DOOR_TO_DOOR_CODE = 'NAD2D';
}

export enum ServiceLevelType {
  AMBULATORY = 'Ambulatory',
  NON_AMBULATORY = 'Non-ambulatory'
}
